import { getErrorMessage } from './getErrorMessage';

const USER_REJECTED_ERROR_MSG = 'Network add denied by user';
const USER_REJECTED_ERROR_TEXT =
  'Failed to switch network. Network switch denied by user';
/**
 * Adds additional error text.
 *
 * @return  custom text + original error
 */
export const getExtendedErrorText = (
  error: unknown,
  additionalText: string,
): string => {
  const message = getErrorMessage(error);

  if (message === USER_REJECTED_ERROR_MSG) {
    return USER_REJECTED_ERROR_TEXT;
  }

  return `${additionalText}. ${message}`;
};
